export const tick_char = '✓';


// WEBPACK FOOTER //
// ./src/components/jobBriefing/JobBrieifingReport/special-char.js